var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-group"},[_c('legend',[_vm._v(_vm._s(_vm.name))]),_vm._t("default"),(_vm.errors)?_c('validation',{attrs:{"name":_vm.name,"errors":_vm.errors}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }